import { render, staticRenderFns } from "./ttshop_usermyorder.vue?vue&type=template&id=18f940b4&scoped=true&"
import script from "./ttshop_usermyorder.vue?vue&type=script&lang=js&"
export * from "./ttshop_usermyorder.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_usermyorder.vue?vue&type=style&index=0&id=18f940b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f940b4",
  null
  
)

export default component.exports